export default __webpack_public_path__ + "static/media/night-light.6b15b535.jpg";